export default function PHP_lstat() {
  return (
    <div>
      <h1>PHP_lstat</h1>
    </div>
  );
}
